import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchSellersFilter } from '../../../../actions/sellersActions';
import {
    fetchEstadosLiquidaciones,
    fetchResultadosLiquidaciones,
    limpiarLiquidacionesBusqueda,
    setFiltroLiquidaciones
} from '../../../../actions/LiquidacionesActions';
import {
    putConfirmaNovedad,
    putEliminaNovedadFinal,
    getEstadosLiquidaciones,
    putEditaNovedadImporte,
    getTiposConceptos
} from '../../../../api/axios';
import { DropDownArrow, customStyle } from '../../../../template/CustomStyle';
import { toast } from 'react-toastify';
import Select from 'react-select';
import NovedadesListItems from './NovedadesListItems';
import { filtroMedioMes } from '../../../../utilities/fechasFiltro';
import { limpiarFiltros } from '../../../../actions/generalActios';
import BigSpinner from '../../../General/BigSpinner';
const fechaFiltro = filtroMedioMes();

function ListNovedadesWrapper(props) {
    const navigate = useNavigate();
    return <ListNovedades {...props} navigate={navigate} />;
}


class ListNovedades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listaTipoEstados: [],
            seller: {
                label: this.props.filtro?.seller?.label ?? "",
                value: this.props.filtro?.seller?.value ?? ""
            },
            estado: {
                label: this.props.filtro?.estado?.label ?? "",
                value: this.props.filtro?.estado?.value ?? ""
            },
            fechaDesde: this.props.filtro?.fechaDesde ?? fechaFiltro.desde,
            fechaHasta: this.props.filtro?.fechaHasta ?? fechaFiltro.hasta,
            ordenDeReferencia: {
                label: this.props.filtro?.ordenDeReferencia?.label ?? "",
                value: this.props.filtro?.ordenDeReferencia?.value ?? ""
            },
            concepto: {
                label: this.props.filtro?.concepto?.label ?? "",
                value: this.props.filtro?.concepto?.value ?? ""
            },
            ordenFecha: this.props.filtro?.ordenFecha ?? "desc",
            listaTipoConcepto: []
        };
        this.INITIAL_REQUEST = {
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            seller: { label: "", value: "" },
            estado: { label: "", value: "" },
            ordenDeReferencia: { label: "", value: "" },
            concepto: { label: "", value: "" },
            ordenFecha: "desc",
            cantidadPagina: 10,
            numeroPagina: 1
        };
    }

    componentDidMount() {
        this.mapEstados();
        this.mapConceptos();

        if (this.props.liquidaciones?.length > 0) {
            return;
        }

        if (this.props.isFilterClear) {
            this.buscarSinFiltro();
        } else {
            this.buscarConFiltro();
        }
    }


    buscarSinFiltro = () => {
        const request = {
            fechaDesde: this.INITIAL_REQUEST.fechaDesde,
            fechaHasta: this.INITIAL_REQUEST.fechaHasta,
            buscaTodo: 1,
            idSeller: 0,
            idEstado: 0,
            ordenDeReferencia: 0,
            idTipoNovedad: 0
        };
        this.props.fetchResultadosLiquidaciones(request);
        this.props.setFiltroLiquidaciones({ ...this.INITIAL_REQUEST });
    }

    buscarConFiltro = () => {
        const filtroParams = {
            fechaDesde: this.props.filtro?.fechaDesde,
            fechaHasta: this.props.filtro?.fechaHasta,
            seller: this.props.filtro?.seller,
            estado: this.props.filtro?.estado,
            concepto: this.props.filtro?.concepto,
            ordenFecha: this.props.filtro?.ordenFecha ?? "desc"
        };
        const request = this.buildRequestFromFiltro(filtroParams);
        this.props.fetchResultadosLiquidaciones(request);

        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse();
        }
    }

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, liquidaciones: false });
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        if (name === "ordenDeReferencia") {
            this.setState({ ordenDeReferencia: { label: value, value: value } });
            return;
        }
        this.setState({ [name]: value });
    }


    mapConceptos = () => {
        getTiposConceptos().then(res => {
            const raw = Array.isArray(res?.listaConceptoNovedades) ? res.listaConceptoNovedades : [];
            const listaAccion = raw.map((tipo) => {
                const idTipo = tipo.idTipoNovedad ?? tipo.IdTipoNovedad ?? 0;
                // Mismo criterio que Crear Novedad: nombre del concepto (Concepto / idConcepto), no la descripción del subtipo.
                const label =
                    tipo.idConcepto ?? tipo.IdConcepto
                    ?? tipo.concepto ?? tipo.Concepto
                    ?? tipo.detalleConcepto ?? tipo.DetalleConcepto
                    ?? tipo.descripcionSubTipoNovedad ?? tipo.DescripcionSubTipoNovedad
                    ?? tipo.descripcionSubTipo ?? tipo.DescripcionSubTipo
                    ?? "";
                return { label, value: String(idTipo) };
            });
            this.setState({ listaTipoConcepto: listaAccion });
        });
    };

    selectSearchHandlerConcepto = (options) => {
        const valor = options ? { label: options.label, value: options.value.toString() } : { label: "", value: "" };
        this.setState({ concepto: valor });
    };

    onOrdenFechaChange = (ordenFechaValue) => {
        this.setState({ ordenFecha: ordenFechaValue });
        this.props.setFiltroLiquidaciones({
            ...this.props.filtro,
            ordenFecha: ordenFechaValue
        });
    };

    ordenarLiquidacionesPorFecha = (lista, orden) => {
        if (!Array.isArray(lista) || lista.length === 0) return lista;
        const copia = [...lista];
        const parseFecha = (fechaStr) => {
            if (!fechaStr) return 0;
            if (fechaStr.includes("/")) {
                const [d, m, y] = fechaStr.split("/");
                return new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10)).getTime();
            }
            return new Date(fechaStr).getTime() || 0;
        };
        copia.sort((a, b) => {
            const tsA = parseFecha(a.fechaNovedad);
            const tsB = parseFecha(b.fechaNovedad);
            return orden === "asc" ? tsA - tsB : tsB - tsA;
        });
        return copia;
    };

    buildRequestFromFiltro = (filtro) => {
        const sellerVal = this.state.seller?.value ?? filtro.seller?.value ?? "";
        const estadoVal = this.state.estado?.value ?? filtro.estado?.value ?? "";
        const ordenRef = this.state.ordenDeReferencia?.value ?? filtro.ordenDeReferencia?.value ?? "";
        const conceptoVal = this.state.concepto?.value ?? filtro.concepto?.value ?? "";

        const request = {
            fechaDesde: filtro.fechaDesde,
            fechaHasta: filtro.fechaHasta,
            buscaTodo: 0,
            idSeller: sellerVal === "" ? 0 : parseInt(sellerVal, 10),
            idEstado: estadoVal === "" ? 0 : parseInt(estadoVal, 10),
            ordenDeReferencia: ordenRef === "" ? 0 : parseInt(ordenRef, 10) || 0,
            idTipoNovedad: conceptoVal === "" ? 0 : parseInt(conceptoVal, 10)
        };
        return request;
    };

    onSubmit = async (event) => {

        event.preventDefault();

        const { fechaDesde, fechaHasta } = this.state;

        if (fechaDesde == "") {
            toast.warn("Debe seleccionar una fecha inicial");
            return;
        }

        if (fechaHasta == "") {
            toast.warn("Debe seleccionar una fecha final");
            return;
        }

        const setFiltroParams = {
            fechaDesde,
            fechaHasta,
            seller: this.state.seller,
            estado: this.state.estado,
            ordenDeReferencia: this.state.ordenDeReferencia,
            concepto: this.state.concepto,
            ordenFecha: this.state.ordenFecha
        };

        this.props.setFiltroLiquidaciones(setFiltroParams);

        const request = this.buildRequestFromFiltro(setFiltroParams);

        this.props.limpiarLiquidacionesBusqueda();
        this.props.fetchResultadosLiquidaciones(request);
        this.setLimpiarFiltroFalse();
    }


    onClear = (e) => {
        e.preventDefault();
        this.setState(prevState => ({
            ...prevState,
            ...this.INITIAL_REQUEST
        }));
        this.buscarSinFiltro();
    };

    confirmarNovedades = (idNovedades) => {

        const data = { id: idNovedades };
        const post = putConfirmaNovedad(data);

        post.then(res => {
            document.getElementById("botonBuscar").click();
            toast.success("La novedades fueron confirmadas con exito");
            return;
        }).catch(err => {
            toast.error("No pudimos confirmar la novedad");
        });
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {
        const valor = { label: options.label, value: options.value.toString() };
        this.setState({ seller: valor });
    }


    selectSearchHandlerLiquidacionesEstado = (options) => {
        const valor = { label: options.label, value: options.value.toString() };
        this.setState({ estado: valor });
    }

    editarNovedad = (idNovedad, nuevoImporte) => {

        const datos = { idNovedad: idNovedad, Importe: nuevoImporte };
        const post = putEditaNovedadImporte(datos);

        post.then(res => {
            document.getElementById("botonBuscar").click();
            toast.success("El importe fue actualizado con exito.");
            return;
        }).catch(err => {
            toast.error("No pudimos editar el importe de esta novedad");
        });
    }

    eliminarNovedad = (idNovedad) => {

        const datos = {
            idsNovedades: [parseInt(idNovedad, 10)]
        };

        const post = putEliminaNovedadFinal(datos);

        post.then(res => {
            document.getElementById("botonBuscar").click();
            toast.success("El novedad fue eliminada con exito.");
            return;
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudimos eliminar la novedad");
        });
    }

    goToNuevaNovedad = () => {
        this.props.navigate("/Novedades/Nueva");
    }

    mapSellers = () => {
        this.props.fetchSellersFilter({
            Descripcion: "",
            Page: 1,
            PageSize: 100
        });
    }

    onSelectSearchInputSellers = (descripcion, action) => {
        if (action.action === 'input-change') {
            this.props.fetchSellersFilter({
                Descripcion: descripcion,
                Page: 1,
                PageSize: 100
            });
        }
    }

    mapEstados = () => {

        getEstadosLiquidaciones().then(res => {
            const raw =
                Array.isArray(res?.listadoEstadosNovedades) ? res.listadoEstadosNovedades :
                    Array.isArray(res?.estados) ? res.estados : [];
            const listaEstados = raw.map((tipo) => ({
                label: tipo.descripcion ?? tipo.Descripcion ?? "",
                value: (tipo.idEstado ?? tipo.IdEstado ?? "").toString()
            }));
            this.setState({ listaTipoEstados: listaEstados });
        });
    }


    render() {

        let listaSellers = Array.isArray(this.props.filteredSellers)
            ? this.props.filteredSellers.map(s => ({ label: s.label, value: s.value.toString() }))
            : [];

        if (listaSellers.length > 0 && listaSellers[0]?.value !== "") {
            listaSellers = [{ value: "", label: "Todos" }, ...listaSellers];
        }

        let liquidaciones = !Array.isArray(this.props.liquidaciones) ? [] : this.props.liquidaciones;
        const ordenFecha = this.state.ordenFecha ?? "desc";
        const liquidacionesOrdenadas = this.ordenarLiquidacionesPorFecha(liquidaciones, ordenFecha);

        return (
            <div className="container-fluid px-3 px-md-4 pb-4">
                <div className="row mb-3 mb-md-4 align-items-center py-3 px-2 rounded" style={{ background: 'linear-gradient(to right, #f8f9fa 0%, #fff 100%)', borderLeft: '4px solid var(--rojo-megatone, #c00)' }}>
                    <div className="col-12 col-md-7">
                        <h4 className="mb-0 text-themecolor color-rojo-megatone fw-bold">Gestión de Novedades</h4>
                        <p className="mb-0 mt-1 small text-muted">Administración y búsqueda de novedades de liquidación</p>
                    </div>
                    <div className="col-12 col-md-5 text-md-end mt-2 mt-md-0">
                        <button
                            onClick={this.goToNuevaNovedad}
                            type="button"
                            className="btn btn-sm btn-success shadow-sm"
                        >
                            <i className="fa fa-plus-circle me-1" /> Crear Novedad
                        </button>
                    </div>
                </div>

                <form className="form-horizontal form-material" onSubmit={this.onSubmit} onReset={this.onClear}>
                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-header bg-light py-2">
                            <h6 className="mb-0 fw-semibold text-dark">Filtros de búsqueda</h6>
                        </div>
                        <div className="card-body p-4">
                            <div className="row justify-content-between g-3">
                                <div className="col-12 col-md-2">

                                    <p className="font-bold mb-1">Desde</p>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="fechaDesde"
                                        onChange={this.myChangeHandler}
                                        value={this.state.fechaDesde}
                                    />
                                </div>

                                <div className="col-12 col-md-2">

                                    <p className="font-bold mb-1">Hasta</p>
                                    <input
                                        type="date"
                                        name="fechaHasta"
                                        className="form-control"
                                        onChange={this.myChangeHandler}
                                        value={this.state.fechaHasta}
                                    />
                                </div>

                                <div className="col-12 col-md-2">

                                    <p className="font-bold mb-1">Seller</p>
                                    <Select
                                        value={this.state.seller}
                                        options={listaSellers}
                                        onChange={this.selectSearchHandlerLiquidacionesSeller}
                                        onMenuOpen={this.mapSellers}
                                        onInputChange={this.onSelectSearchInputSellers}
                                        styles={customStyle}
                                        components={{ DropdownIndicator: () => DropDownArrow }}
                                    />
                                </div>

                                <div className="col-12 col-md-2">

                                    <p className="font-bold mb-1">Estados</p>
                                    <Select
                                        value={this.state.estado}
                                        options={this.state.listaTipoEstados}
                                        onChange={this.selectSearchHandlerLiquidacionesEstado}
                                        onMenuOpen={this.mapEstados}
                                        styles={customStyle}
                                        components={{ DropdownIndicator: () => DropDownArrow }}
                                    />
                                </div>

                                <div className="col-12 col-md-2">

                                    <p className="font-bold mb-1">Orden De Referencia</p>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="ordenDeReferencia"
                                        min={0}
                                        onChange={this.myChangeHandler}
                                        value={this.state.ordenDeReferencia?.value ?? ""}
                                    />
                                </div>

                                <div className="col-12 col-md-2">

                                    <p className="font-bold mb-1">Concepto</p>
                                    <Select
                                        value={this.state.concepto}
                                        options={this.state.listaTipoConcepto}
                                        onChange={this.selectSearchHandlerConcepto}
                                        onMenuOpen={this.mapConceptos}
                                        styles={customStyle}
                                        components={{ DropdownIndicator: () => DropDownArrow }}
                                    />
                                </div>
                            </div>

                            <div className="row mt-4 pt-3 border-top border-light">
                                <div className="col-12 text-center text-sm-end">
                                    <button
                                        type="submit"
                                        id="botonBuscar"
                                        className="btn btn-sm background-rojo-megatone text-white shadow-sm"
                                        disabled={this.props.isLoadingLiquidaciones}
                                    >
                                        <i className="fa fa-search me-1" /> Buscar
                                    </button>
                                    <button
                                        type="reset"
                                        id="botonReset"
                                        className="btn btn-sm btn-secondary btn-limpiar-novedades ms-2"
                                        disabled={this.props.isLoadingLiquidaciones}
                                    >
                                        Limpiar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                {
                    this.props.isLoadingLiquidaciones ? (
                        <div className="card shadow-sm border-0">
                            <div className="card-body py-5">
                                <div className="d-flex justify-content-center">
                                    <BigSpinner />
                                </div>
                            </div>
                        </div>
                    ) : liquidaciones.length === 0 ? (
                        <div className="card shadow-sm border-0">
                            <div className="card-body py-5 text-center">
                                <i className="fa fa-inbox fa-3x text-muted mb-3" />
                                <h5 className="text-muted">No se encontraron resultados</h5>
                                <p className="text-muted small mb-0">Ajuste los filtros e intente nuevamente.</p>
                            </div>
                        </div>
                    ) : (
                        <NovedadesListItems
                            liquidaciones={liquidacionesOrdenadas}
                            confirmarNovedadesFunction={this.confirmarNovedades}
                            editarNovedadFunction={this.editarNovedad}
                            eliminarNovedadFunction={this.eliminarNovedad}
                            ordenFecha={ordenFecha}
                            onOrdenFechaChange={this.onOrdenFechaChange}
                        />
                    )
                }
            </div>
        );
    }
}


const mapStateToProps = state => {
    const lr = state.liquidaciones?.lista_resultados_liquidaciones;
    const liquidaciones =
        Array.isArray(lr) ? lr :
            (Array.isArray(lr?.novedades) ? lr.novedades :
                (Array.isArray(lr?.elementos) ? lr.elementos :
                    (Array.isArray(lr?.content) ? lr.content : [])));
    return ({
        tipoUsuario: state.general.tipoUsuario,
        isLoadingLiquidaciones: state.liquidaciones.isLoadingLiquidaciones,
        liquidaciones,
        filteredSellers: state.sellers.filteredSellers,
        filtro: state.liquidaciones.filtro,
        emptyFilters: state.general.limpiar,
        isFilterClear: state.general.limpiar.liquidaciones,
    });
};

export default connect(mapStateToProps, {
    limpiarLiquidacionesBusqueda,
    fetchSellersFilter,
    fetchResultadosLiquidaciones,
    fetchEstadosLiquidaciones,
    setFiltroLiquidaciones,
    limpiarFiltros
})(ListNovedadesWrapper);
